import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { STColumn, STModule } from '@delon/abc/st';
import { _HttpClient } from '@delon/theme';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-concurrent-user',
  templateUrl: './concurrent-user.component.html',
  standalone: true,
  imports: [CommonModule, STModule, NzModalModule],
  styleUrls: ['./concurrent-user.component.less']
})
export class ConcurrentUsersComponent implements OnInit {
  data: any[] = [];
  columns: STColumn[] = [
    { title: 'User', index: 'userDisplay' },
    { title: 'Email', index: 'userEmail' },
    { title: 'Browser', index: 'terminalName' },
    {
      title: 'Type',
      index: 'accountant',
      type: 'enum',
      enum: {
        false: 'Standard',
        true: 'Accountant'
      }
    },
    { title: 'Origin', index: 'origin' }
  ];

  constructor(
    private http: _HttpClient,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.http.get('api/license/ActiveTerminals').subscribe((res: any) => {
      this.data = [...res];
      this.cdr.detectChanges();
    });
  }
}
